import { render, staticRenderFns } from "./serviceProject.vue?vue&type=template&id=782e5048&scoped=true&"
import script from "./serviceProject.vue?vue&type=script&lang=js&"
export * from "./serviceProject.vue?vue&type=script&lang=js&"
import style0 from "./serviceProject.vue?vue&type=style&index=0&lang=css&"
import style1 from "./serviceProject.vue?vue&type=style&index=1&id=782e5048&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782e5048",
  null
  
)

export default component.exports